import { IVideo } from '../../types/builder';
import { IApplicationState } from '../../types/redux';

const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;

export const selectVideos = (state: IApplicationState): IVideo[] | undefined => {
  return state.builderCard.videos?.filter(({ url }) => regExp.test(url));
};
